import { render, staticRenderFns } from "./ProgramTables.vue?vue&type=template&id=06264098&"
import script from "./ProgramTables.vue?vue&type=script&lang=js&"
export * from "./ProgramTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports